import { tagsReducers } from './reducers';
import { tagsSaga } from './sagas';

export { tagsReducers, tagsSaga };
